import en from './en-US';
import fr from './fr-FR';
import es from './es-ES';

export default {
  ...en,
  ...fr,
  ...es,
};
